<template>
    <div>
        <ul class="nav nav-pills  small">
            <li class="mr-3" style="margin-right:30px;"><span class="float-right">{{baseSymbol}}/{{quoteSymbol}}</span></li>
            <li v-for="(label, res) in resolutions" class="nav-item">
                <a href="#" @click.prevent="setResolution(res)" :class="{'nav-item active strong': res == resolution, 'nav-item': res !=resolution}">{{ label }}</a>
            </li>
        </ul>
        <div id="candles" class="row justify-content-center align-items-center">
        </div>
    </div>
</template>

<script>
import {createChart} from 'lightweight-charts';

export default {
    name: "tvChart",
    props: ['base', 'quote'],
    data() {
        return {
            quoteSymbol: this.quote || 'USDC',
            baseSymbol: this.base || 'SOL',
            resolution: 60,
            resolutions: {
                '1': '1m',
                '3': '3m',
                '5': '5m',
                '15': '15m',
                '30': '30m',
                '60': '1h',
                '240': '4h',
                'D': '1D',
            },
            chart: null,
            candlestickSeries: null,
            series: [],
        }
    },
    mounted() {
        console.log(this.$refs)
        this.chart = createChart(document.getElementById('candles'), {
            width: 630,
            height: 500,
            timeScale: {
                timeVisible: true,
                secondsVisible: false
            },
            layout: {
                backgroundColor: '#f8f8fc', //'#ffffff', //'#f8f8fc',
                textColor: 'rgba(152, 166, 190, .7)' //'#98a6be'
            },
            grid: {
                horzLines: {
                    color: '#cfcfcf',
                    visible: false,
                },
                vertLines: {
                    color: '#cfcfcf',
                    visible: false,
                },
            },
        })
        this.candlestickSeries = this.chart.addCandlestickSeries({
            priceFormat: {
                type: 'price',
                // precision: 7,
                minMove: 0.000001,
            },
        });
        // this.candlestickSeries.setData([]);
        this.getChartData()
        window.setInterval(this.getChartData, 30000) // update every 30s.. should do this based on resolution i guess?
    },
    methods: {
        setResolution(res) {
            this.resolution = res
            this.getChartData(true)
        },
        getChartData(reset = false) {
            let now = new Date().getTime() / 1000
            let res = this.resolution
            if (res === '1D') res = 60 * 24
            let start = now - (res * 60 * 50); // 50 candles at x minutes * 60 s each
            axios.get('https://api.solanacompass.com/tv/history?resolution=' + res + '&symbol=' + this.baseSymbol + '/' + this.quoteSymbol + '&from=' + start + '&to=' + now)
                .then(response => {
                    console.log(response)
                    let series = []
                    response.data.t.forEach((timestamp, index) => {
                        series.push({
                            time: timestamp,
                            open: response.data.o[index],
                            high: response.data.h[index],
                            low: response.data.l[index],
                            close: response.data.c[index],
                        })
                        //                            volume: response.data.v[index]

                    })
                    console.log(series.sort((a, b) => a.time - b.time))
                    // build whole chart if we don't have one yet

                    // let r = this.candlestickSeries.setData(series)
                    if ((reset) || (this.series.length === 0)) {
                        console.log('setting all data')
                        this.candlestickSeries.setData(series)
                    }
                    else {
                        console.log('updating chart data')
                        // otherwise just update last two candles
                        this.candlestickSeries.update(series[series.length - 2])
                        this.candlestickSeries.update(series[series.length - 1])
                    }
                    this.series = series
                    this.chart.timeScale().fitContent()
                    // console.log(this.chart)
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }

}
</script>

<style scoped>

</style>
